// @ts-nocheck
import { useSettingsCollection } from "@store/Framework/Store/Context/ContextHooks";
import ForterFingerprint from "@store/Components/Toolkit/Injectors/FraudProtection/ForterFingerprint";
import SignifydFingerprint from "@store/Components/Toolkit/Injectors/FraudProtection/SignifydFingerprint";
import React, { FC } from "react";

const FraudProtectionFingerprint: FC = () => {
    const settings = useSettingsCollection();

    if (settings.extensionSignifydConnectorSettings?.enableConnector) {
        return <SignifydFingerprint />;
    }

    if (settings.extensionForterConnectorSettings?.enableConnector) {
        return <ForterFingerprint />;
    }

    return null;
};

export default FraudProtectionFingerprint;
